export class AESEncryptionDecryption {
    static decryptWithAES(plaintext: any, key: string): string {
        var CryptoJS = require("crypto-js");

        let decrypted = CryptoJS.enc.Base64.parse(plaintext).toString(CryptoJS.enc.Utf8);
        let bytes = CryptoJS.AES.decrypt(decrypted, key).toString(CryptoJS.enc.Utf8);

        console.log("Decrypted Data: " + bytes);

        return bytes;
    }

    static decryptWithAESSha1(plaintext: string, key: string): string {
        var CryptoJS = require("crypto-js");

        var result = CryptoJS.AES.decrypt(plaintext, CryptoJS.enc.Base64.parse(key),
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        );
        return decodeURIComponent(result.toString(CryptoJS.enc.Utf8));
    }
    static decryptRC4TextKey = (encryptedText: string, keyString: string): string => {
        try {
            let base64 = encryptedText
                .replace(/ /g, '+')
                .replace(/-/g, '+')
                .replace(/_/g, '/');

            while (base64.length % 4) {
                base64 += '=';
            }

            const rawCiphertext = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
            const encoder = new TextEncoder();
            const rawKey = encoder.encode(keyString);

            const s = new Uint8Array(256);
            for (let x = 0; x < 256; x++) {
                s[x] = x;
            }

            let j = 0;
            for (let x = 0; x < 256; x++) {
                // FIX: Corrected parenthesis for array index bounds
                j = (j + s[x] + rawKey[x % rawKey.length]) % 256;
                const temp = s[x];
                s[x] = s[j];
                s[j] = temp;
            }

            let i = 0;
            j = 0;
            const decryptedBytes = new Uint8Array(rawCiphertext.length);

            for (let k = 0; k < rawCiphertext.length; k++) {
                i = (i + 1) % 256;
                j = (j + s[i]) % 256;

                const temp = s[i];
                s[i] = s[j];
                s[j] = temp;

                const t = (s[i] + s[j]) % 256;
                decryptedBytes[k] = rawCiphertext[k] ^ s[t];
            }

            return new TextDecoder("utf-8").decode(decryptedBytes);

        } catch (error) {
            console.error("RC4 Decryption execution crashed:", error);
            return '';
        }
    }
    static encryptWithAES(plaintext: string, key: string): string {
        var CryptoJS = require("crypto-js");

        var ciphertext = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(
            CryptoJS.AES.encrypt(plaintext, key).toString()));

        console.log("Encrypted Data: " + ciphertext);

        return ciphertext;
    }
}  



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/aseencryption.tsx